import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { ENVIRONMENT } from '../../../environments/environment';

/** Same storage key as legacy `LandingDinamicaAuthService` / `lealcoinswebapp`. */
const LEAL_ACCESS_TOKEN_STORAGE_KEY = 'lealToken';

/**
 * Client-credentials OAuth2 for Leal API (OTP generate/validate and similar).
 * Token endpoint is NOT routed through {@link lealOtpAuthInterceptor} (different URL path).
 */
@Injectable({ providedIn: 'root' })
export class LealOauthTokenService {
  private readonly http = inject(HttpClient);

  getStoredAccessToken(): string | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    return localStorage.getItem(LEAL_ACCESS_TOKEN_STORAGE_KEY);
  }

  saveAccessToken(token: string): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    localStorage.setItem(LEAL_ACCESS_TOKEN_STORAGE_KEY, token);
  }

  /**
   * POST `oauth2/token` with `grant_type=client_credentials` (legacy contract).
   */
  fetchClientCredentialsToken(): Observable<{ access_token: string }> {
    const cfg = ENVIRONMENT.lealOAuth;
    if (!cfg?.authUrl?.trim() || !cfg.clientAuthorizationHeader?.trim()) {
      return throwError(() => new Error('lealOAuth is not configured in environment'));
    }
    const url = `${cfg.authUrl.replace(/\/$/, '')}/oauth2/token`;
    const body = new HttpParams().set('grant_type', 'client_credentials');
    const headers = new HttpHeaders({
      Authorization: cfg.clientAuthorizationHeader,
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    return this.http.post<{ access_token: string }>(url, body.toString(), { headers });
  }
}
